const mutations = {
  'SET_PASSWORDS' (state, { passwords }) {
    state.services = passwords;
  },
  'SET_PASSWORD' (state, { password }) {
    state.service = password;
  }
}

export default mutations